<template>
  <div
    class="bg-gradient-black-01 w-full flex-shrink-0 space-y-4 overflow-hidden rounded-xl p-6 ring-1 ring-gray-200/10 lg:max-w-sm">
    <slot />
  </div>
</template>
